import { useContext, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import MyTextField from "../../components/inputs/MyTextField";
import MyButton from "../../components/MyButton";
import { useAuth } from "../../hooks/useAuth";
import { SiteContext } from "../../context/SiteProvider";

const FindId = () => {
  const { setLoadingScreen } = useContext(SiteContext);
  const { findIdMutation } = useAuth();
  const navigate = useNavigate();

  const [result, setResult] = useState("");

  const initValues = {
    userName: "",
    email: "",
  };

  const validationSchema = yup.object({
    userName: yup.string().required("필수 입력 항목입니다."),
    email: yup
      .string()
      .email("이메일 형식이 올바르지 않습니다.")
      .required("이메일을 입력해 주세요."),
  });
  const methods = useForm({
    defaultValues: initValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    setLoadingScreen(true);

    findIdMutation.mutate(data, {
      onSuccess: (res) => {
        if (res?.idList?.length) {
          setResult(res.idList[0]);
          methods.clearErrors("email");
        }
      },
      onError: (error) => {
        if (error.data.code === "NOT_FOUND") {
          methods.setError("email", {
            message: "사용자가 존재하지 않습니다.",
          });
        } else {
          alert("검색 중 오류가 발생했습니다.");
        }
      },
      onSettled: () => {
        setLoadingScreen(false);
      },
    });
  };

  return (
    <div
      className="flex items-center bg-cover bg-right-top bg-no-repeat login-page md:py-6 py-3"
      style={{
        backgroundImage: "url(/assets/img/logbg.png)",
        minHeight: "calc(100vh - 182px)",
      }}
    >
      <div className="container flex justify-center">
        <div className="max-w-[470px] w-full">
          {!result ? (
            <>
              <h2 className="mb-1 font-bold lg:text-4xl sm:text-3xl text-xl text-center">
                아이디 찾기
              </h2>

              <p className="md:text-lg md:mb-10 mb-6 text-center">
                등록된 회원정보로 아이디를 찾으실 수 있습니다.
              </p>

              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <div className="flex flex-wrap md:mb-5 mb-3">
                    <label htmlFor="userName" className="w-full font-semibold">
                      성명
                    </label>
                    <div className="w-full">
                      <MyTextField
                        id="userName"
                        name="userName"
                        placeholder="회원가입 시 입력하신 성명을 입력해주세요."
                      />
                    </div>
                  </div>

                  <div className="flex flex-col md:mb-5 mb-3">
                    <label htmlFor="email" className="w-full font-semibold">
                      이메일
                    </label>
                    <div className="w-full">
                      <MyTextField
                        id="email"
                        name="email"
                        placeholder="회원가입 시 입력하신 이메일 주소를 입력해주세요."
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap md:mt-5 mt-3 gap-4 gap-y-4">
                    <MyButton
                      variant="contained"
                      color="primary"
                      className="flex-1 sm:min-w-[48%] font-semibold min-w-full h-[56px]"
                      type="submit"
                      size="small"
                    >
                      로그인
                    </MyButton>
                    <MyButton
                      variant="outlined"
                      className="flex-1 sm:min-w-[48%] min-w-full h-[56px]"
                      size="small"
                      onClick={() => navigate("/Login")}
                    >
                      <span className="text-sm">취소</span>
                    </MyButton>
                  </div>
                </form>
              </FormProvider>
            </>
          ) : (
            <>
              <p className="md:text-lg md:mb-10 mb-6 text-center">
                회원님의 아이디는 다음과 같습니다.
              </p>

              <p className="font-semibold md:mb-10 mb-6 text-center">
                {result}
              </p>

              <div className="flex flex-wrap md:mt-5 mt-3 gap-4 gap-y-4">
                <MyButton
                  variant="contained"
                  color="primary"
                  className="flex-1 sm:min-w-[48%] min-w-full font-semibold h-[56px]"
                  size="small"
                  onClick={() => navigate("/Login")}
                >
                  로그인
                </MyButton>
                <MyButton
                  variant="outlined"
                  className="flex-1 sm:min-w-[48%] min-w-full h-[56px]"
                  size="small"
                  onClick={() => navigate("/ForgotPassword")}
                >
                  <span className="text-sm">비밀번호 찾기</span>
                </MyButton>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FindId;
